import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, PRIMARY_OUTLET, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs';
import { BreadcrumbService } from '../services/breadcrumbService.js'
import { Location } from '@angular/common';
@Component({
  selector: 'app-breadcrumb',
  standalone: false,
  templateUrl: './breadcrumb.html',
  styleUrl: './breadcrumb.less'
})
export class Breadcrumb implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);
  breadcrumbService = inject(BreadcrumbService);
  // breadcrumbs : Breadcrumbs[] = [];
  // label:any;
  // pathUrl:any;
  constructor() {

  }


  ngOnInit(): void {
    console.log('Breadcrumb component initialized');
  }

  goBack() {
    console.log('goBack() called - returning to previous page');
    this.location.back();
  }





}
